// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__LQ8PV","signatureButtonsRight":"ModalSign_signatureButtonsRight__q6z2_"};